export default "__VITE_ASSET__CdHBZSoT__"